import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { emptyTrainingSession, TrainingSession } from "../../../../interfaces/training-session";
import { deleteTrainingSession, getTrainingSessionSingle } from "../../../../services/training-session";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface CoachTrainingSessionDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function CoachTrainingSessionDelete(props: CoachTrainingSessionDeleteProps) {
    const [trainingSession, setTraining] = useState<TrainingSession>(emptyTrainingSession);

    const handleDelete = () => {
        deleteTrainingSession(props.id)
            .then(response => {
                props.onDelete(props.id);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getTrainingSessionSingle(props.id)
            .then(response => {
                setTraining(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="training-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_training_session") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { trainingSession.id == 0 && 
                    <LoadingSpinner />
                }
                { trainingSession.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_training_session_message"
                                values={{
                                    training_session_name: trainingSession.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}